import React from 'react';
import EchoToggle from "../../../components/EchoToggle";

const NotificationSettings = ({ 
  notificationSettings, 
  templates, 
  loadingTemplates,
  hasNotificationChanges,
  savingNotificationSettings,
  onNotificationToggle,
  onTemplateSelect,
  onLoadTemplates,
  onSaveSettings,
  onShowMacroModal,
  onShowExampleModal
}) => {
  const getToggleValue = (value, fallback = false) =>
    typeof value === 'boolean' ? value : fallback;

  return (
    <div style={{ padding: "20px", borderBottom: "1px solid #E6EDEC" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
        {/* [모바일 수정] nowrap + minWidth:0 조합이 폰에서 좌측 설명을 폭 0까지
            짓눌러 글자가 한 자씩 세로로 흘렀다(스크린샷 재현). wrap + 최소폭 확보. */}
        <div style={{ flex: "1", minWidth: "220px" }}>
          <h4 style={{ marginBottom: "8px", color: "#333", whiteSpace: "nowrap" }}>알림톡 설정</h4>
          <p style={{ fontSize: "14px", color: "#666", margin: "0", lineHeight: "1.4" }}>
            지필 과제 생성 및 채점 완료 시 자동으로 알림톡을 발송할 수 있습니다.
          </p>
        </div>
        <div style={{ display: "flex", gap: "8px", flexShrink: 0, marginLeft: "20px", flexWrap: "wrap" }}>
          <button
            onClick={onLoadTemplates}
            disabled={loadingTemplates}
            style={{
              padding: "8px 16px",
              fontSize: "12px",
              fontWeight: 600,
              borderRadius: "999px",
              backgroundColor: "#FFF",
              border: `1px solid ${loadingTemplates ? "#E6EDEC" : "#00A396"}`,
              color: loadingTemplates ? "#7A8490" : "#00A396",
              cursor: loadingTemplates ? "not-allowed" : "pointer",
              transition: "background-color .2s, color .2s",
              whiteSpace: "nowrap",
              fontFamily: "inherit",
            }}
            onMouseOver={(e) => {
              if (!loadingTemplates) {
                e.currentTarget.style.backgroundColor = "#E5FBF8";
              }
            }}
            onMouseOut={(e) => {
              if (!loadingTemplates) {
                e.currentTarget.style.backgroundColor = "#FFF";
              }
            }}
          >
            {loadingTemplates ? "동기화 중..." : "센드온과 동기화"}
          </button>
          <button
            onClick={onSaveSettings}
            disabled={!hasNotificationChanges || savingNotificationSettings}
            style={{
              padding: "8px 16px",
              fontSize: "12px",
              fontWeight: 600,
              borderRadius: "999px",
              backgroundColor: hasNotificationChanges && !savingNotificationSettings ? "#0E141B" : "#E6EDEC",
              border: "none",
              color: hasNotificationChanges && !savingNotificationSettings ? "#FFF" : "#7A8490",
              cursor: hasNotificationChanges && !savingNotificationSettings ? "pointer" : "not-allowed",
              transition: "background-color .2s",
              whiteSpace: "nowrap",
              fontFamily: "inherit",
            }}
            onMouseOver={(e) => {
              if (hasNotificationChanges && !savingNotificationSettings) {
                e.currentTarget.style.backgroundColor = "#00A396";
              }
            }}
            onMouseOut={(e) => {
              if (hasNotificationChanges && !savingNotificationSettings) {
                e.currentTarget.style.backgroundColor = "#0E141B";
              }
            }}
          >
            {savingNotificationSettings ? "저장 중..." : "설정 저장"}
          </button>
        </div>
      </div>
      
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(300px, 100%), 1fr))", gap: "14px" }}>
        {/* 알림장 발송 시 알림 */}
        <div style={{
          padding: "16px",
          border: "1px solid #E6EDEC",
          borderRadius: "18px",
          backgroundColor: "#F4F8F7"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                알림장 발송 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                알림장 발송 버튼 클릭 시 항상 알림톡이 발송됩니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <EchoToggle
                  checked={notificationSettings.classNoticeEnabled}
                  onChange={() => onNotificationToggle('classNoticeEnabled')}
                />
            </div>
          </div>

          {notificationSettings.classNoticeEnabled && (
            <>
              <div style={{ marginTop: "12px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  사용할 템플릿 선택
                </label>
                <select
                  value={notificationSettings.classNoticeTemplate}
                  onChange={(e) => onTemplateSelect('classNoticeTemplate', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">템플릿을 선택해주세요</option>
                  {templates.map(template => (
                    <option
                      key={template.id}
                      value={template.sendon_template_id || template.id}
                      disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                    >
                      {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' :
                       template.status === 'DRAFT' ? '작성중' :
                       template.status === 'PENDING' ? '검수대기' :
                       template.status === 'IN_REVIEW' ? '검수중' :
                       template.status || '알 수 없음'})
                    </option>
                  ))}
                </select>
                {loadingTemplates && (
                  <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                    템플릿 목록을 불러오는 중...
                  </p>
                )}
                {!loadingTemplates && templates.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#C2452D", marginTop: "4px" }}>
                    사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                  </p>
                )}
              </div>

              {/* 수신자 선택 */}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'classNoticeSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 알림장 알림이 발송됩니다.',
                  defaultValue: false,
                }, {
                  field: 'classNoticeSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 알림장 알림이 발송됩니다.',
                  defaultValue: true,
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "11px 13px",
                        backgroundColor: "#FFF",
                        borderRadius: "12px",
                        border: "1px solid #E6EDEC",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <EchoToggle
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                        />
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* 과제 배정 시 알림 (새 섹션) */}
        <div style={{
          padding: "16px",
          border: "1px solid #E6EDEC",
          borderRadius: "18px",
          backgroundColor: "#F4F8F7"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                과제 배정 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                과제가 있는 알림장 발송 시 추가로 알림톡이 발송됩니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <EchoToggle
                  checked={notificationSettings.homeworkAssignedEnabled}
                  onChange={() => onNotificationToggle('homeworkAssignedEnabled')}
                />
            </div>
          </div>

          {notificationSettings.homeworkAssignedEnabled && (
            <>
              <div style={{ marginTop: "12px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  사용할 템플릿 선택
                </label>
                <select
                  value={notificationSettings.homeworkAssignedTemplate}
                  onChange={(e) => onTemplateSelect('homeworkAssignedTemplate', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">템플릿을 선택해주세요</option>
                  {templates.map(template => (
                    <option
                      key={template.id}
                      value={template.sendon_template_id || template.id}
                      disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                    >
                      {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' :
                       template.status === 'DRAFT' ? '작성중' :
                       template.status === 'PENDING' ? '검수대기' :
                       template.status === 'IN_REVIEW' ? '검수중' :
                       template.status || '알 수 없음'})
                    </option>
                  ))}
                </select>
                {loadingTemplates && (
                  <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                    템플릿 목록을 불러오는 중...
                  </p>
                )}
                {!loadingTemplates && templates.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#C2452D", marginTop: "4px" }}>
                    사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                  </p>
                )}
              </div>

              {/* 수신자 선택 */}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'homeworkAssignedSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 과제 배정 알림이 발송됩니다.',
                  defaultValue: false,
                }, {
                  field: 'homeworkAssignedSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 과제 배정 알림이 발송됩니다.',
                  defaultValue: true,
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "11px 13px",
                        backgroundColor: "#FFF",
                        borderRadius: "12px",
                        border: "1px solid #E6EDEC",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <EchoToggle
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                        />
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* 채점 완료 시 알림 */}
        <div style={{
          padding: "16px",
          border: "1px solid #E6EDEC",
          borderRadius: "18px",
          backgroundColor: "#F4F8F7"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                지필 과제 채점 완료 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                지필 과제 채점이 완료될 때 선택한 대상에게 알림을 발송합니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <EchoToggle
                  checked={notificationSettings.gradingCompletedEnabled}
                  onChange={() => onNotificationToggle('gradingCompletedEnabled')}
                />
            </div>
          </div>
          
          {notificationSettings.gradingCompletedEnabled && (
            <div style={{ marginTop: "12px" }}>
              <label style={{ 
                display: "block", 
                marginBottom: "8px", 
                fontSize: "14px", 
                fontWeight: "600", 
                color: "#333" 
              }}>
                사용할 템플릿 선택
              </label>
              <select
                value={notificationSettings.gradingCompletedTemplate}
                onChange={(e) => onTemplateSelect('gradingCompletedTemplate', e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "14px",
                  backgroundColor: "white"
                }}
              >
                <option value="">템플릿을 선택해주세요</option>
                {templates.map(template => (
                  <option 
                    key={template.id} 
                    value={template.sendon_template_id || template.id}
                    disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                  >
                    {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' : 
                     template.status === 'DRAFT' ? '작성중' :
                     template.status === 'PENDING' ? '검수대기' :
                     template.status === 'IN_REVIEW' ? '검수중' : 
                     template.status || '알 수 없음'})
                  </option>
                ))}
              </select>
              {loadingTemplates && (
                <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                  템플릿 목록을 불러오는 중...
                </p>
              )}
              {!loadingTemplates && templates.length === 0 && (
                <p style={{ fontSize: "12px", color: "#C2452D", marginTop: "4px" }}>
                  사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                </p>
              )}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'gradingCompletedSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 채점 완료 알림이 발송됩니다.',
                  defaultValue: false,
                }, {
                  field: 'gradingCompletedSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 채점 완료 알림이 발송됩니다.',
                  defaultValue: true,
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "11px 13px",
                        backgroundColor: "#FFF",
                        borderRadius: "12px",
                        border: "1px solid #E6EDEC",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <EchoToggle
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                        />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div style={{ 
        marginTop: "16px",
        padding: "11px 14px",
        backgroundColor: "#F4F8F7",
        borderRadius: "12px"
      }}>
        <p style={{ margin: "0", fontSize: "13px", color: "#3A434E" }}>
          <strong style={{ color: "#00A396" }}>참고</strong>{" "} 알림톡 템플릿은 '알림톡 관리' 탭에서 생성하고 관리할 수 있습니다. 
          승인된 템플릿만 선택 가능합니다.
        </p>
      </div>
    </div>
  );
};

export default NotificationSettings;
